import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;


@Component({
  selector: 'app-inquery-list',
  templateUrl: './inquery-list.component.html',
  styleUrls: ['./inquery-list.component.scss']
})
export class InqueryListComponent {

  public dataListing:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  
  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('hva_login') || "{}");   
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

     getDetail(page:any){ 
      this.loading=true;
      var url:any='';
      if(this.searchKey==''){
        url='/contact-us?page=' +page;   
      } else {
        url='/contact-us?page=' +page+'&search='+ this.searchKey; 
      }
      this.service.GetApi(url).subscribe(((response:any)=>{
        if(response.success ==1) {  
          var self =this;  
          this.loading=false;
          this.dataListing=response.data.record;
          this.totalCount =response.data.total;
        } else {
          this.dataListing=[];
          this.totalCount =0;
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

    reset(){
      this.p=1;
      this.searchKey='';
      this.getDetail(this.p);
    }
  

    redirect(data:any){
      // localStorage.setItem('hva_messageView',JSON.stringify(data));
      // this.router.navigate(['/inquiry-detail']);
  
    }
}
